/**
 * @generated SignedSource<<f8fce20a5b4d37ea0785042ea7fb1210>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"QuickView_itemSearch">;
  readonly " $fragmentType": "ProductBaseTile_itemSearch";
};
export type ProductBaseTile_itemSearch$key = {
  readonly " $data"?: ProductBaseTile_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickView_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "2166662159c3097d0ea59152486e8e7b";

export default node;
